import {MeshButtonDBType, MeshButtonType} from "../../components/annotations/ts/ButtonsTypes";
import * as THREE from "three";

export const  MeshButtonsDB: Array<MeshButtonDBType> = [
    {
        button_id: 'VENEXC_T053',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: false,
        // outlinerColor: new THREE.Color(0x0000FF),
        outlinerColor: new THREE.Color(0xFFFF00),
    },
    {
        button_id: 'VENEXC_T054',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: false,
        outlinerColor: new THREE.Color(0x0000FF),
        // outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'VENEXC_T055',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: false,
        // outlinerColor: new THREE.Color(0x0000FF),
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'VENEXC_T056',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: false,
        // outlinerColor: new THREE.Color(0x0000FF),
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'NANCIT_T057',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: false,
        // outlinerColor: new THREE.Color(0x0000FF),
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'NANCIT_T058',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: false,
        // outlinerColor: new THREE.Color(0x0000FF),
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'NANCIT_T059',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: false,
        // outlinerColor: new THREE.Color(0x0000FF),
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'NANCIT_T060',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: false,
        // outlinerColor: new THREE.Color(0x0000FF),
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'NANCIT_T061',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: false,
        // outlinerColor: new THREE.Color(0x0000FF),
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'NANDEPW127',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        // outlinerColor: new THREE.Color(0x0000FF),
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'ARM_CID_T049',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        // outlinerColor: new THREE.Color(0x0000FF),
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'ARM_CID_T050',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        // outlinerColor: new THREE.Color(0x0000FF),
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'ARM_CID_T051',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        // outlinerColor: new THREE.Color(0x0000FF),
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'ARM_CID_T052',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        // outlinerColor: new THREE.Color(0x0000FF),
        outlinerColor: new THREE.Color(0xFFFFFF),
    },

    {
        button_id: 'VENTHE_P076',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        // outlinerColor: new THREE.Color(0x0000FF),
        outlinerColor: new THREE.Color(0xFFFFFF),
    },

     {
        button_id: 'ARM_THE_P064',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        // outlinerColor: new THREE.Color(0x0000FF),
        outlinerColor: new THREE.Color(0xFFFFFF),
    },

    // {
    //     button_id: 'HKT_P013',
    //     meshButtonType: MeshButtonType.BasicMeshButton,
    //     useOutliner: true,
    //     // outlinerColor: new THREE.Color(0x0000FF),
    //     outlinerColor: new THREE.Color(0xFFFFFF),
    // },

]
